import { useEffect, useRef } from 'react'
import gsap from 'gsap'

const CONFETTI_COLORS = ['#F2994A', '#F2C94C', '#6FCF97', '#56CCF2', '#BB6BD9']
const PARTICLE_COUNT = 18

export const useHeardiversaryConfetti = () => {
  const emojiRef = useRef<HTMLSpanElement>(null)
  const containerRef = useRef<HTMLSpanElement>(null)

  useEffect(() => {
    const emoji = emojiRef.current
    const container = containerRef.current
    if (!emoji || !container) return () => {}

    const particles: HTMLSpanElement[] = []

    for (let i = 0; i < PARTICLE_COUNT; i++) {
      const p = document.createElement('span')
      p.style.cssText = `
        position: absolute;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: ${CONFETTI_COLORS[i % CONFETTI_COLORS.length]};
        pointer-events: none;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        opacity: 0;
      `
      container.appendChild(p)
      particles.push(p)
    }

    const tl = gsap.timeline({ delay: 0.2 })

    // Emoji bounce
    tl.fromTo(
      emoji,
      { scale: 1 },
      { scale: 1.3, duration: 0.25, ease: 'back.out(2)', yoyo: true, repeat: 1 }
    )

    // Confetti burst
    particles.forEach((p, i) => {
      const angle = (i / PARTICLE_COUNT) * 360
      const rad = (angle * Math.PI) / 180
      const dist = 28 + Math.random() * 20
      const x = Math.cos(rad) * dist
      const y = Math.sin(rad) * dist

      tl.fromTo(
        p,
        { x: 0, y: 0, opacity: 1, scale: 1 },
        {
          x,
          y,
          opacity: 0,
          scale: 0.4,
          duration: 0.6,
          ease: 'power2.out',
        },
        '<'
      )
    })

    return () => {
      tl.kill()
      particles.forEach((p) => p.remove())
    }
  }, [])

  return { emojiRef, containerRef }
}
